import { Container } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import styled from 'styled-components';
import { NavigationContainer as NavigationContainerREACT } from './NavigationContainer';
import { NavigationContainerProps } from './NavigationContainer.types';
import { AemContainerConfig } from '../../molecules/Navigation';

const StyledNavigationContainerWrapper = styled.div`
  left: 50%;
  margin-left: -50dvw;
  margin-right: -50dvw;
  position: relative;
  right: 50%;
  width: 100dvw;
`;

export const NavigationContainerWrapper = (props: NavigationContainerProps) => {
  const { cqPath = '', isAuthorMode = false } = props;
  const NavigationContainerConfig: AemContainerConfig = {
    emptyLabel: 'Marriott Navigation Container',
    isEmpty: () => false,
    resourceType: `mi-aem-homepage-spa/components/content/global-navigation`,
    cqPath: cqPath,
    isInEditor: !!isAuthorMode,
  };

  return (
    <StyledNavigationContainerWrapper data-testid="navigation-container-wrapper">
      <Container
        {...NavigationContainerConfig}
        className={clsx({ 'py-0': isAuthorMode })}
        childPages={<NavigationContainerREACT {...props} />}
      />
    </StyledNavigationContainerWrapper>
  );
};
